import DefaultTemplate from '@templates/DefaultTemplate';
import {Wrapper} from './GuardianPage.styled';
import {useEffect, useRef, useState} from 'react';
import db from '@utils/db';
import {useStore} from '@store/appStore';
import {useAuthentication} from '@providers/AuthProvider';
import {useRouter} from 'next/router';
import Profile from '@components/Profile';
import Guardian from "@components/Guardian";


export const GuardianPage = (props:{isTeacher?:boolean}) => {
    const [badgeSplash, setBadgeSplash] = useState(null);
    const [total, setTotal] = useState(null);
    const [registrations, setRegistrations] = useState(null);
    const [day, setDay] = useState(null);
    const [coursePercent, setcoursePercent] = useState(null);
    const [courses, setCourses] = useState(null);
    const [load, setLoad] = useState(false);
    const { client, whoIsLoggedIn, filterDate } = useStore();


    useEffect(() => {
        //if (total !== null && registrations !== null && day !== null && coursePercent !== null && courses !== null && !props.isTeacher)
        //profile.current.rewardScreen()
    }, [total, registrations, day, coursePercent, courses])

    useEffect(() => {
        if (!client) return;
        setLoad(true);
    }, [client, filterDate]);


    return (
        <Wrapper>
            <Guardian />
        </Wrapper>
    );
};

export default GuardianPage;
